// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"50b31f88","885":"3977cef0","931":"f541e992","977":"97045b4f"}[chunkId] + ".chunk.js";
};